module.exports = __webpack_public_path__ + "img/face11.5839877e.jpg";